<template>
  <v-responsive
    @click="setActive"
    class="rotator-slide__wrapper"
    :aspect-ratio="aspectRatio"
  >
    <div :class="classList" :style="styles">
      <div class="rotator-slide--bg" v-if="slide.title"></div>
      <div class="rotator-slide__label">
        <div class="earlier">Earlier</div>
        <div class="just_posted">Just posted</div>
        <div v-if="slide.start_at_day">
          Coming on
          {{
            slide.start_at_day | moment("timezone", "America/New_York", "MM/DD")
          }}
        </div>
      </div>
      <div class="rotator-slide__text">
        <div class="rotator-slide__text-name">{{ slide.title }}</div>
      </div>

      <div class="rotator-slide__now-playing" v-if="slide.vimeo_id">
        now playing
      </div>
    </div>
  </v-responsive>
</template>

<script>
import videoPlaceholder from "@/assets/video-placeholder-1-thumb.jpg";

export default {
  name: "MomentRotatorSlide",
  props: {
    value: Number,
    slide: Object,
  },
  methods: {
    setActive() {
      if (this.slide.posted) {
        this.$emit("input", this.slide.id);

        if (this.slide.url) {
          window.open(this.slide.url, "_blank");
        }
      }
    },
  },
  computed: {
    classList() {
      const { id, status } = this.slide;
      return {
        active: id == this.value,
        earlier: status == "earlier",
        just_posted: status == "just_posted",
        soon: status == "coming_soon",
        "rotator-slide": true,
      };
    },
    styles() {
      const preview = this.slide.preview_urls?.thumb;
      const placeholderPreview = videoPlaceholder;

      return {
        backgroundImage: `url(${preview || placeholderPreview})`,
      };
    },
    aspectRatio() {
      const aspectRatio = {
        sm: 16 / 11,
        xs: 2.6,
      };

      return aspectRatio[this.$size] || 16 / 8;
    },
  },
};
</script>

<style scoped lang="scss">
.rotator-slide__wrapper {
  overflow: visible;
  padding: 4px;
}
.rotator-slide {
  font-family: "Roboto Condensed";
  background: black;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  font-weight: 600;
  font-size: 1em;
  display: flex;
  align-items: center;
  text-align: center;
  background-size: cover;
  background-position: center;
  position: relative;

  &--bg {
    border-radius: 10px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(16, 24, 32, 0.6),
      rgba(16, 24, 32, 0.6)
    );
  }

  &__text {
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #ffffff;
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 600;
    position: relative;
    width: 100%;
    padding: 10px;

    &-name {
    }
  }

  &__now-playing {
    font-family: "Noto Sans", sans-serif;
    font-weight: bold;
    font-size: 9px;
    line-height: 12px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    background: white;
    display: inline-block;
    position: absolute;
    color: #101820;
    padding: 4px 11px;
    border-radius: 20px;
    left: 50%;
    bottom: -10px;
    margin-left: -46px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
    display: none;
  }

  &.active {
    box-shadow: 0px 0px 1px 4px $primary;
  }

  &.active &__now-playing {
    display: block;
  }

  &__label {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 1em;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #b1b3b3;
    position: absolute;
    top: -30px;
    align-self: flex-start;

    .earlier,
    .just_posted,
    .soon {
      display: none;
    }
  }

  &.earlier .earlier,
  &.just_posted .just_posted,
  &.soon .soon {
    display: block !important;
  }
}
</style>
